export interface StatutSca {
    Code?: string,
    Libelle?: string
}

const VALIDE: string = "VAL";
const EN_ERREUR: string = "ENE";
const VALIDATION_EN_ATTENTE: string = "VEA";
const A_FAIRE: string = "AFA";

export const StatutSca = {
    VALIDATION_EN_ATTENTE,
    A_FAIRE,
    EN_ERREUR,
    VALIDE
}